import React from 'react';
import { Text } from '@ydistri/ds';
import useDelayedFlag from '../../../../hooks/useDelayedFlag';

export const IMPORT_WAITING_DELAY_MS = 10_000;

interface ImportWaitingHintProps {
  pending: boolean;
}

/** Below the actions of an import step whose request has been running for ten seconds. */
const ImportWaitingHint: React.FC<ImportWaitingHintProps> = ({ pending }) => {
  const waiting = useDelayedFlag(pending, IMPORT_WAITING_DELAY_MS);

  return waiting ? (
    <Text data-testid="import-waiting-hint">
      The import may be waiting for another import or a cleanup to finish.
    </Text>
  ) : null;
};

export default ImportWaitingHint;
